module.exports = __webpack_public_path__ + "static/cloud-0032a354a888a5ba69103e85ccfab1f2.png";